import { AdvancedFilter } from '../../components/molecules/FilterBar';
import { FILTER_FIELD_DEFINITIONS } from '../../components/molecules/FilterBar/AddFilterModal.types';

export const parseAdvancedFilters = (searchParams: URLSearchParams): AdvancedFilter[] => {
  const out: AdvancedFilter[] = [];
  for (const raw of searchParams.getAll('af')) {
    // Each segment is encodeURIComponent-encoded by the writer so values
    // containing the `|` delimiter round-trip safely.
    const parts = raw.split('|').map(decodeAfSegment);
    if (parts.length < 3) continue;
    const [dataKey, operator, value, value2] = parts;
    if (!dataKey || !operator) continue;
    // Drop incomplete `between` entries — without both bounds the filter
    // chip renders a half-empty range and `buildFilterModel` only emits
    // one half of the date pair. Treat the whole entry as malformed.
    if (operator === 'between' && (!value || !value2)) continue;
    const def = FILTER_FIELD_DEFINITIONS.find((f) => f.key === dataKey);
    const type = def?.type ?? 'text';
    const fieldLabel = def?.name ?? dataKey;
    if (operator === 'between') {
      out.push({
        field: fieldLabel,
        dataKey,
        type,
        operator,
        value,
        value2,
        dateFrom: type === 'date' ? value : undefined,
        dateTo: type === 'date' ? value2 : undefined,
        display: `${fieldLabel} between ${value} and ${value2}`,
      });
    } else {
      out.push({
        field: fieldLabel,
        dataKey,
        type,
        operator,
        value: value ?? '',
        display: `${fieldLabel} ${operator} ${value ?? ''}`,
      });
    }
  }
  return out;
};

const decodeAfSegment = (segment: string): string => {
  try {
    return decodeURIComponent(segment);
  } catch {
    // Malformed `%xx` sequences fall back to the raw segment rather than
    // throwing — better to surface the literal text than to break the
    // entire `af` parse for the page.
    return segment;
  }
};

export const serializeAdvancedFilter = (adv: AdvancedFilter): string => {
  if (adv.operator === 'between') {
    const fromValue = adv.dateFrom ?? adv.value ?? '';
    const toValue = adv.dateTo ?? adv.value2 ?? '';
    return [adv.dataKey, 'between', fromValue, toValue].map(encodeURIComponent).join('|');
  }
  return [adv.dataKey, adv.operator, adv.value ?? ''].map(encodeURIComponent).join('|');
};
